import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NOT_FOUND_URL } from "./config/appConfig";

const NotFound = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to the external URL after the component loads
        window.location.href = NOT_FOUND_URL;
    }, [navigate]);

    return null; // You could add a loading spinner or message if needed
};

export default NotFound;
